import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useSocket } from '@/contexts/SocketContext';
import { agentAPI } from '../api/agent.api';

export const useAgentStatus = () => {
  const queryClient = useQueryClient();
  const { socket } = useSocket();

  const { data, isLoading } = useQuery({
    queryKey: ['agent-status'],
    queryFn: () => agentAPI.getStatus(),
    staleTime: 30000,
    gcTime: 60000,
    refetchInterval: 60000, // Refresh every minute
  });

  useEffect(() => {
    if (!socket) return;

    const handleUpdate = () => {
      queryClient.invalidateQueries({ queryKey: ['agent-status'] });
    };

    socket.on('agent:status:updated', handleUpdate);

    return () => {
      socket.off('agent:status:updated', handleUpdate);
    };
  }, [socket, queryClient]);

  return {
    status: data?.data || {
      last_check_at: undefined,
      last_analysis_at: undefined,
      last_execution_at: undefined,
      is_running: false,
      current_task: undefined,
    },
    isLoading,
  };
};
